import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router";
import Assessment from "./Assessment";
import { useDispatch, useSelector } from "react-redux";
import { selectModuleAndTopicForActivity } from "../../store/selectors";
import BurndownChart from "./BurndownChart";
import { updateCurrentTopic } from "../../store/actions";
import Orientation from "./Orientation";
import { logEvent, logInteractionEvent } from "../../utils/appInsight";
import Activity from "./Activity";
import { updateCurrentPositionThunk } from "../../store/thunks";

const ActivityPage = () => {
  const { activityId } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const data = useSelector((state) =>
    selectModuleAndTopicForActivity(state, activityId)
  );
  const activity = useSelector((state) => state.activities[activityId]);
  const section = useSelector((state) => state.progress.section);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (activityId !== "assessment") {
      dispatch(updateCurrentPositionThunk(location.pathname));
    }
  }, [location.pathname]);

  useEffect(() => {
    if (data.topic) {
      logEvent({
        name: "ActivityStarted",
        properties: {
          section,
          moduleKey: data.topic.parentContentId,
          topicKey: data.topic.contentKey,
          activityKey: data.topic.data.activity.activityKey,
        },
      });
      logInteractionEvent("ActivityStarted", {
        section,
        topicKey: data.topic.contentKey,
        activityKey: data.topic.data.activity.activityKey,
      });
      dispatch(updateCurrentTopic(data.topic.contentKey));
    }
  }, [data.topic, dispatch, section]);

  switch (activityId) {
    case "assessment":
      return <Assessment />;
    case "burndown-chart":
      return <BurndownChart section={data.module} topic={data.topic} />;

    case "orientation":
      return <Orientation />;
    default:
      return activity ? (
        <Activity
          section={data.module}
          topic={data.topic}
          activity={activity}
        />
      ) : (
        <Assessment />
      );
  }
};

export default ActivityPage;
